module.exports = __webpack_public_path__ + "static/homepageBG2-716d13975a161b7e4da0b1551375b53f.jpg";